export const ROLE = {
  VENTANERO: "ventanero",
  CALLCENTER: "callcenter",
  COORDINADOR: "coordinador",
};
